import { formatDistanceToNowStrict, parseISO } from 'date-fns';
import { getDateFnsLocale } from './getLocale';

export const timeAgo = (timestamp: string) => {
  return formatDistanceToNowStrict(parseISO(timestamp), {
    locale: getDateFnsLocale(),
    addSuffix: true,
  });
};
